module.exports = __webpack_public_path__ + "img/1L1.a578ce44.png";